/**
 * 获取两数乘以一定比例后,较小的一个
 * @param multiplier1 乘数1
 * @param multiplier2 乘数2
 * @param number1 计算比例数1
 * @param number2 计算比例数2
 * @param ratio 比例
 * @returns 两数中比例值小的一个
 */
 export function getTwoNumberSmall(
	multiplier1: number,
	number1: number,
	multiplier2: number,
	number2: number,
	ratio: number
) {
	let a = (multiplier1 * ratio) / number1
	let b = (multiplier2 * ratio) / number2
	return a > b ? b : a
}

export const i18n = {
    zh: {
        RESET: '重置',
        ROTATE_LEFT: '向左选择',
        ROTATE_RIGHT: '向右选装',
        CLOSE: '关闭',
        NEXT: '下一张',
        PREV: '上一张'
    },
    en: {
        RESET: 'reset',
        ROTATE_LEFT: 'rotate left',
        ROTATE_RIGHT: 'rotate right',
        CLOSE: 'close',
        NEXT: 'next',
        PREV: 'prev'
    }
}